<template>
    <div>
        <li v-for="(item, index) in logs">
            {{item[0]}}
            <span v-if="item[1]">:</span>
            <span style="color: red">
            {{item[1]}}
            </span>
            >>
            <span class="primary-color">
                {{item[2]}}
            </span>
        </li>
    </div>
</template>

<script>
export default {
  name: 'HistoryLog',
  props: {
    logsString: {
      type: String,
      default: ''
    },
  },
  mounted() {
      try {
          this.logs = JSON.parse(this.logsString);
      } catch (e) {
          this.logs = [];
      }
  },
  data: () => ({
    logs: []
  }),
  methods: {

  }
}
</script>

<style scoped lang="sass">

</style>
